import Vue from 'vue'
import VueFilters from 'vue2-filters'

Vue.use(VueFilters)
